import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

const TAX = 0.07;

const Cart = () => {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const nav = useNavigate();
  const tax = subtotal * TAX;
  const total = subtotal + tax;

  if (items.length === 0) {
    return (
      <div className="max-w-xl mx-auto px-4 pt-28 pb-24 text-center">
        <ShoppingBag className="h-14 w-14 text-[#c9ad7f] mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold text-[#2c1e12]">Your cart is empty</h1>
        <p className="text-[#8a7458] mt-1">Add some homemade meals to get started.</p>
        <Link to="/menu" className="mt-5 inline-flex rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold px-6 py-3 transition-colors">Browse Menu</Link>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto px-4 pt-20 pb-28">
      <h1 className="font-heading text-3xl font-bold text-[#2c1e12] mb-4">Your Cart</h1>
      <div className="space-y-3">
        {items.map((item) => (
          <div key={item.id} className="flex gap-3 bg-[#f6ece0] rounded-2xl p-3">
            {item.image && <img src={item.image} alt={item.name} className="h-20 w-20 rounded-xl object-cover" />}
            <div className="flex-1 min-w-0">
              <p className="font-medium text-[#2c1e12] leading-snug">{item.name}</p>
              <p className="text-sm font-bold text-[#9a4a2f] mt-0.5">${item.price.toFixed(2)}</p>
              <div className="flex items-center gap-2 mt-2">
                <button onClick={() => updateQty(item.id, item.qty - 1)} className="h-7 w-7 rounded-full border border-[#d8c6a4] flex items-center justify-center text-[#6b5844] hover:bg-[#efe3cd]"><Minus className="h-3.5 w-3.5" /></button>
                <span className="w-6 text-center font-medium">{item.qty}</span>
                <button onClick={() => updateQty(item.id, item.qty + 1)} className="h-7 w-7 rounded-full border border-[#d8c6a4] flex items-center justify-center text-[#6b5844] hover:bg-[#efe3cd]"><Plus className="h-3.5 w-3.5" /></button>
                <button onClick={() => removeItem(item.id)} className="ml-auto text-[#b06a4a] hover:text-[#9a4a2f]"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5 rounded-2xl bg-[#f7e4df] p-4 space-y-2">
        <div className="flex justify-between text-[#6b5844]"><span>Subtotal</span><span>${subtotal.toFixed(2)}</span></div>
        <div className="flex justify-between text-[#6b5844]"><span>Tax (7%)</span><span>${tax.toFixed(2)}</span></div>
        <div className="flex justify-between font-bold text-lg text-[#2c1e12] pt-1 border-t border-[#e9c9c0]"><span>Total</span><span>${total.toFixed(2)}</span></div>
      </div>

      <button onClick={() => nav("/checkout")} className="mt-4 w-full rounded-xl bg-[#9a4a2f] hover:bg-[#853e26] text-white font-semibold py-3.5 transition-colors">Continue to Checkout</button>
    </div>
  );
};

export default Cart;
